/*
 * @Author: Tahiti
 * @Date: 2025-01-27 12:00:00
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-06 22:49:14
 * @Description: 首页多语言配置
 * @FilePath: /weryai-web/locales/modules/homepage.ts
 */
export default {
    zh: {
        // 导航菜单
        home: '首页',
        videoAI: '视频 AI',
        imageAI: '图像 AI',
        aiTools: '编辑工具',
        pricingLink: '价格',
        login: '登录',
        startFree: '免费开始',

        // 首页分类标题
        characters: '角色',

        // 视频AI下拉菜单
        imageToVideoAI: '图生视频 AI',
        imageToVideoAIDesc: '将静止图像制作成逼真的动态视频。',
        textToVideoAI: '文生视频 AI',
        textToVideoAIDesc: '将简单的文本提示转换成令人惊叹、引人入胜的视频。',
        aiVideoEditor: 'AI 视频编辑器',
        aiVideoEditorDesc: '使用简单的文本提示即可立即编辑视频。',
        aiWatermarkRemoval: 'AI 去水印',
        aiWatermarkRemovalDesc: '智能识别并移除视频中的水印。',
        aiVideoFaceSwap: 'AI 视频换脸',
        aiVideoFaceSwapDesc: '将一个人的脸替换到另一个人的视频中。',
        aiVideoLipSync: 'AI 对口型',
        aiVideoLipSyncDesc: '让视频中的人物与音频完美同步。',
        aiVideoStylization: 'AI 视频风格化',
        aiVideoEnhancement: 'AI 视频增强',

        // 图像AI下拉菜单
        textToImageAI: '文生图 AI',
        textToImageAIDesc: '将文本描述转换为精美的图像。',
        imageToImageAI: '图生图 AI',
        imageToImageAIDesc: '基于现有图像生成新的变体。',
        aiImageGenerator: 'AI 图像生成器',
        aiImageGeneratorDesc: '使用 AI 技术创建独特的图像。',
        aiImageTranslation: 'AI 图片翻译',
        aiImageTranslationDesc: '智能翻译图片中的文字内容。',
        aiImageRatioConversion: 'AI 图片比例转换',
        aiImageRatioConversionDesc: '智能调整图片的宽高比例。',
        aiImageQualityUpgrade: 'AI 图片画质升级',
        aiImageQualityUpgradeDesc: '提升图片的清晰度和质量。',

        // 编辑工具分类
        videoTools: '视频工具',
        imageTools: '图像工具',
        viewMore: '查看更多',
        supportedVideoModels: '支持的视频模型',
        supportedImageModels: '支持的图像模型',

        // 主要内容
        generateVideo: '生成视频',
        generateImage: '生成图片',
        tryFluxKontext: 'Try Flux Kontext on 微鲤AI',
        noCreditCardRequired: 'No credit card required',

        // 页脚
        tagline: '您的一站式AI 视频和图像创作平台',
        copyright: 'Copyright © 2025 微鲤AI',
    },
    en: {
        // Navigation Menu
        home: 'Home',
        videoAI: 'Video AI',
        imageAI: 'Image AI',
        aiTools: 'Editor Toolkits',
        pricingLink: 'Pricing',
        login: 'Login',
        startFree: 'Start Free',

        // Homepage Category Titles
        characters: 'Characters',

        // Video AI Dropdown
        imageToVideoAI: 'Image to Video AI',
        imageToVideoAIDesc:
            'Transform static images into realistic dynamic videos.',
        textToVideoAI: 'Text to Video AI',
        textToVideoAIDesc:
            'Convert simple text prompts into stunning, engaging videos.',
        aiVideoEditor: 'AI Video Editor',
        aiVideoEditorDesc: 'Edit videos instantly with simple text prompts.',
        aiWatermarkRemoval: 'AI Watermark Removal',
        aiWatermarkRemovalDesc:
            'Intelligently identify and remove watermarks from videos.',
        aiVideoFaceSwap: 'AI Video Face Swap',
        aiVideoFaceSwapDesc:
            "Replace one person's face with another in videos.",
        aiVideoLipSync: 'AI Video Lip Sync',
        aiVideoLipSyncDesc:
            'Perfectly synchronize video characters with audio.',
        aiVideoStylization: 'AI Video Stylization',
        aiVideoEnhancement: 'AI Video Enhancement',

        // Image AI Dropdown
        textToImageAI: 'Text to Image AI',
        textToImageAIDesc: 'Transform text descriptions into beautiful images.',
        imageToImageAI: 'Image to Image AI',
        imageToImageAIDesc: 'Generate new variants based on existing images.',
        aiImageGenerator: 'AI Image Generator',
        aiImageGeneratorDesc: 'Create unique images using AI technology.',
        aiImageTranslation: 'AI Image Translation',
        aiImageTranslationDesc:
            'Intelligently translate text content in images.',
        aiImageRatioConversion: 'AI Image Ratio Conversion',
        aiImageRatioConversionDesc: 'Intelligently adjust image aspect ratios.',
        aiImageQualityUpgrade: 'AI Image Quality Upgrade',
        aiImageQualityUpgradeDesc: 'Enhance image clarity and quality.',

        // AI Tools Categories
        videoTools: 'Video Tools',
        imageTools: 'Image Tools',
        viewMore: 'View More',
        supportedVideoModels: 'Supported Video Models',
        supportedImageModels: 'Supported Image Models',

        // Main Content
        generateVideo: 'Generate Video',
        generateImage: 'Generate Image',
        tryFluxKontext: 'Try Flux Kontext on 微鲤AI',
        noCreditCardRequired: 'No credit card required',

        // Footer
        tagline: 'Your one-stop AI video and image creation platform',
        copyright: 'Copyright © 2025 微鲤AI',
    },
    ja: {
        // Navigation Menu
        home: 'ホーム',
        videoAI: '動画 AI',
        imageAI: '画像 AI',
        aiTools: '編集ツールキット',
        pricingLink: '料金',
        login: 'ログイン',
        startFree: '無料で開始',

        // Homepage Category Titles
        characters: 'キャラクター',

        // Video AI Dropdown
        imageToVideoAI: '画像から動画 AI',
        imageToVideoAIDesc: '静止画像をリアルな動画に変換します。',
        textToVideoAI: 'テキストから動画 AI',
        textToVideoAIDesc:
            'シンプルなテキストプロンプトを魅力的な動画に変換します。',
        aiVideoEditor: 'AI 動画エディター',
        aiVideoEditorDesc:
            'シンプルなテキストプロンプトで動画を即座に編集します。',
        aiWatermarkRemoval: 'AI 透かし除去',
        aiWatermarkRemovalDesc: '動画の透かしを智能的に識別・除去します。',
        aiVideoFaceSwap: 'AI 動画顔交換',
        aiVideoFaceSwapDesc: '動画で一人の顔を別の人に置き換えます。',
        aiVideoLipSync: 'AI 動画リップシンク',
        aiVideoLipSyncDesc: '動画キャラクターと音声を完璧に同期させます。',

        // Image AI Dropdown
        textToImageAI: 'テキストから画像 AI',
        textToImageAIDesc: 'テキストの説明を美しい画像に変換します。',
        imageToImageAI: '画像から画像 AI',
        imageToImageAIDesc:
            '既存の画像に基づいて新しいバリエーションを生成します。',
        aiImageGenerator: 'AI 画像ジェネレーター',
        aiImageGeneratorDesc: 'AI 技術を使用してユニークな画像を作成します。',
        aiImageTranslation: 'AI 画像翻訳',
        aiImageTranslationDesc:
            '画像内のテキストコンテンツを智能的に翻訳します。',
        aiImageRatioConversion: 'AI 画像比率変換',
        aiImageRatioConversionDesc: '画像のアスペクト比を智能的に調整します。',
        aiImageQualityUpgrade: 'AI 画像品質向上',
        aiImageQualityUpgradeDesc: '画像の鮮明度と品質を向上させます。',

        // Main Content
        tryFluxKontext: 'Flux Kontext を試す',
        noCreditCardRequired: 'クレジットカード不要',

        // Footer
        tagline: 'あなたのワンストップ AI 動画・画像作成プラットフォーム',
        copyright: 'Copyright © 2025 微鲤AI',
        aiVideoStylization: 'AI動画スタイリング',
        aiVideoEnhancement: 'AI動画高画質化',
        videoTools: '動画ツール',
        imageTools: '画像ツール',
        viewMore: 'もっと見る',
        supportedVideoModels: '対応動画モデル',
        supportedImageModels: '対応画像モデル',
        generateVideo: '動画を生成',
        generateImage: '画像を生成',
    },
    ko: {
        // Navigation Menu
        home: '홈',
        videoAI: '비디오 AI',
        imageAI: '이미지 AI',
        aiTools: '편집 툴킷',
        pricingLink: '가격',
        login: '로그인',
        startFree: '무료로 시작',

        // Homepage Category Titles
        characters: '캐릭터',

        // Video AI Dropdown
        imageToVideoAI: '이미지에서 비디오 AI',
        imageToVideoAIDesc: '정적 이미지를 현실적인 동영상으로 변환합니다.',
        textToVideoAI: '텍스트에서 비디오 AI',
        textToVideoAIDesc: '간단한 텍스트 프롬프트를 멋진 비디오로 변환합니다.',
        aiVideoEditor: 'AI 비디오 에디터',
        aiVideoEditorDesc: '간단한 텍스트 프롬프트로 비디오를 즉시 편집합니다.',
        aiWatermarkRemoval: 'AI 워터마크 제거',
        aiWatermarkRemovalDesc:
            '비디오의 워터마크를 지능적으로 식별하고 제거합니다.',
        aiVideoFaceSwap: 'AI 비디오 얼굴 교체',
        aiVideoFaceSwapDesc:
            '비디오에서 한 사람의 얼굴을 다른 사람으로 교체합니다.',
        aiVideoLipSync: 'AI 비디오 립싱크',
        aiVideoLipSyncDesc: '비디오 캐릭터와 오디오를 완벽하게 동기화합니다.',
        videoTools: '비디오 도구',
        imageTools: '이미지 도구',

        // Image AI Dropdown
        textToImageAI: '텍스트에서 이미지 AI',
        textToImageAIDesc: '텍스트 설명을 아름다운 이미지로 변환합니다.',
        imageToImageAI: '이미지에서 이미지 AI',
        imageToImageAIDesc: '기존 이미지를 기반으로 새로운 변형을 생성합니다.',
        aiImageGenerator: 'AI 이미지 생성기',
        aiImageGeneratorDesc: 'AI 기술을 사용하여 고유한 이미지를 생성합니다.',
        aiImageTranslation: 'AI 이미지 번역',
        aiImageTranslationDesc:
            '이미지의 텍스트 콘텐츠를 지능적으로 번역합니다.',
        aiImageRatioConversion: 'AI 이미지 비율 변환',
        aiImageRatioConversionDesc: '이미지의 종횡비를 지능적으로 조정합니다.',
        aiImageQualityUpgrade: 'AI 이미지 품질 향상',
        aiImageQualityUpgradeDesc: '이미지의 선명도와 품질을 향상시킵니다.',

        // Main Content
        tryFluxKontext: 'Flux Kontext 를 시도하십시오',
        noCreditCardRequired: '크레딧 카드가 필요하지 않습니다',

        // Footer
        tagline: '원스톱 AI 비디오 및 이미지 생성 플랫폼',
        copyright: 'Copyright © 2025 微鲤AI',
        aiVideoStylization: 'AI 비디오 스타일화',
        aiVideoEnhancement: 'AI 비디오 강화',
        viewMore: '더 보기',
        supportedVideoModels: '지원되는 비디오 모델',
        supportedImageModels: '지원되는 이미지 모델',
        generateVideo: '비디오 생성',
        generateImage: '이미지 생성',
    },
    tw: {
        // 導航選單
        home: '首頁',
        videoAI: '影片 AI',
        imageAI: '圖像 AI',
        aiTools: '編輯工具',
        pricingLink: '價格',
        login: '登入',
        startFree: '免費開始',

        // 首頁分類標題
        characters: '角色',

        // 影片 AI 下拉選單
        imageToVideoAI: '圖生影片 AI',
        imageToVideoAIDesc: '將靜態圖像製作成逼真的動態影片。',
        textToVideoAI: '文生影片 AI',
        textToVideoAIDesc: '將簡單文字提示轉換成令人驚豔、引人入勝的影片。',
        aiVideoEditor: 'AI 影片編輯器',
        aiVideoEditorDesc: '使用簡單文字提示即可立即編輯影片。',
        aiWatermarkRemoval: 'AI 去浮水印',
        aiWatermarkRemovalDesc: '智慧辨識並移除影片中的浮水印。',
        aiVideoFaceSwap: 'AI 影片換臉',
        aiVideoFaceSwapDesc: '將一個人的臉替換到另一個人的影片中。',
        aiVideoLipSync: 'AI 對口型',
        aiVideoLipSyncDesc: '讓影片中的人物與音訊完美同步。',
        aiVideoStylization: 'AI 影片風格化',
        aiVideoEnhancement: 'AI 影片增強',

        // 圖像 AI 下拉選單
        textToImageAI: '文生圖 AI',
        textToImageAIDesc: '將文字描述轉換為精美的影像。',
        imageToImageAI: '圖生圖 AI',
        imageToImageAIDesc: '基於現有影像生成新的變體。',
        aiImageGenerator: 'AI 圖像生成器',
        aiImageGeneratorDesc: '使用 AI 技術創造獨特影像。',
        aiImageTranslation: 'AI 圖片翻譯',
        aiImageTranslationDesc: '智慧翻譯圖片中的文字內容。',
        aiImageRatioConversion: 'AI 圖片比例轉換',
        aiImageRatioConversionDesc: '智慧調整圖片的寬高比例。',
        aiImageQualityUpgrade: 'AI 圖片畫質升級',
        aiImageQualityUpgradeDesc: '提升圖片清晰度與品質。',

        // 編輯工具分類
        videoTools: '影片工具',
        imageTools: '圖片工具',
        viewMore: '查看更多',
        supportedVideoModels: '支援的影片模型',
        supportedImageModels: '支援的圖像模型',

        // 主要內容
        generateVideo: '生成影片',
        generateImage: '生成圖片',
        tryFluxKontext: '在 微鲤AI 試用 Flux Kontext',
        noCreditCardRequired: '無需信用卡',

        // 頁尾
        tagline: '您的一站式 AI 影片與圖像創作平台',
        copyright: 'Copyright © 2025 微鲤AI',
    },
    pl: {
        // Navigation Menu
        home: 'Strona główna',
        videoAI: 'Wideo AI',
        imageAI: 'Obrazy AI',
        aiTools: 'Narzędzia edycji',
        pricingLink: 'Cennik',
        login: 'Zaloguj się',
        startFree: 'Zacznij za darmo',

        // Homepage Category Titles
        characters: 'Postacie',

        // Video AI Dropdown
        imageToVideoAI: 'AI obraz→wideo',
        imageToVideoAIDesc:
            'Zamieniaj statyczne obrazy w realistyczne, dynamiczne wideo.',
        textToVideoAI: 'AI tekst→wideo',
        textToVideoAIDesc:
            'Zamień proste prompty w efektowne, angażujące wideo.',
        aiVideoEditor: 'Edytor wideo AI',
        aiVideoEditorDesc: 'Edytuj wideo natychmiast dzięki prostym promptom.',
        aiWatermarkRemoval: 'Usuwanie znaków wodnych AI',
        aiWatermarkRemovalDesc:
            'Inteligentnie rozpoznawaj i usuwaj znaki wodne z wideo.',
        aiVideoFaceSwap: 'Zamiana twarzy w wideo AI',
        aiVideoFaceSwapDesc:
            'Zamień twarz jednej osoby na inną w wideo.',
        aiVideoLipSync: 'Synchronizacja ust AI',
        aiVideoLipSyncDesc:
            'Idealna synchronizacja ruchu ust z dźwiękiem.',
        aiVideoStylization: 'Stylizacja wideo AI',
        aiVideoEnhancement: 'Poprawa jakości wideo AI',

        // Image AI Dropdown
        textToImageAI: 'AI tekst→obraz',
        textToImageAIDesc: 'Zamień opis tekstowy w piękne obrazy.',
        imageToImageAI: 'AI obraz→obraz',
        imageToImageAIDesc: 'Generuj nowe warianty na bazie istniejących obrazów.',
        aiImageGenerator: 'Generator obrazów AI',
        aiImageGeneratorDesc: 'Twórz unikalne obrazy z wykorzystaniem AI.',
        aiImageTranslation: 'Tłumaczenie obrazów AI',
        aiImageTranslationDesc:
            'Inteligentne tłumaczenie tekstu na obrazach.',
        aiImageRatioConversion: 'Zmiana proporcji obrazu AI',
        aiImageRatioConversionDesc: 'Inteligentne dopasowanie proporcji obrazu.',
        aiImageQualityUpgrade: 'Poprawa jakości obrazu AI',
        aiImageQualityUpgradeDesc: 'Zwiększ ostrość i jakość obrazu.',

        // AI Tools Categories
        videoTools: 'Narzędzia wideo',
        imageTools: 'Narzędzia obrazów',
        viewMore: 'Zobacz więcej',
        supportedVideoModels: 'Obsługiwane modele wideo',
        supportedImageModels: 'Obsługiwane modele obrazów',

        // Main Content
        generateVideo: 'Generuj wideo',
        generateImage: 'Generuj obraz',
        tryFluxKontext: 'Wypróbuj Flux Kontext w 微鲤AI',
        noCreditCardRequired: 'Nie jest wymagana karta kredytowa',

        // Footer
        tagline: 'Twoja kompleksowa platforma do tworzenia wideo i obrazów AI',
        copyright: 'Copyright © 2025 微鲤AI',
    },
    es: {
        // Navigation Menu
        home: 'Inicio',
        videoAI: 'Video AI',
        imageAI: 'Imagen AI',
        aiTools: 'Kits de edición',
        pricingLink: 'Precios',
        login: 'Iniciar Sesión',
        startFree: 'Comenzar Gratis',

        // Homepage Category Titles
        characters: 'Personajes',

        // Video AI Dropdown
        imageToVideoAI: 'Imagen a Video AI',
        imageToVideoAIDesc:
            'Transforma imágenes estáticas en videos dinámicos realistas.',
        textToVideoAI: 'Texto a Video AI',
        textToVideoAIDesc:
            'Convierte prompts de texto simples en videos impresionantes.',
        aiVideoEditor: 'Editor de Video AI',
        aiVideoEditorDesc:
            'Edita videos instantáneamente con prompts de texto simples.',
        aiWatermarkRemoval: 'Eliminación de Marca de Agua AI',
        aiWatermarkRemovalDesc:
            'Identifica y elimina inteligentemente marcas de agua de videos.',
        aiVideoFaceSwap: 'Intercambio de Cara en Video AI',
        aiVideoFaceSwapDesc:
            'Reemplaza la cara de una persona con otra en videos.',
        aiVideoLipSync: 'Sincronización de Labios en Video AI',
        aiVideoLipSyncDesc:
            'Sincroniza perfectamente personajes de video con audio.',
        videoTools: 'Herramientas de vídeo',
        imageTools: 'Herramientas de imagen',

        // Image AI Dropdown
        textToImageAI: 'Texto a Imagen AI',
        textToImageAIDesc:
            'Transforma descripciones de texto en imágenes hermosas.',
        imageToImageAI: 'Imagen a Imagen AI',
        imageToImageAIDesc:
            'Genera nuevas variantes basadas en imágenes existentes.',
        aiImageGenerator: 'Generador de Imágenes AI',
        aiImageGeneratorDesc: 'Crea imágenes únicas usando tecnología AI.',
        aiImageTranslation: 'Traducción de Imagen AI',
        aiImageTranslationDesc:
            'Traduce inteligentemente contenido de texto en imágenes.',
        aiImageRatioConversion: 'Conversión de Proporción de Imagen AI',
        aiImageRatioConversionDesc:
            'Ajusta inteligentemente las proporciones de imagen.',
        aiImageQualityUpgrade: 'Mejora de Calidad de Imagen AI',
        aiImageQualityUpgradeDesc:
            'Mejora la claridad y calidad de las imágenes.',

        // Main Content
        tryFluxKontext: 'Prueba Flux Kontext en 微鲤AI',
        noCreditCardRequired: 'No se requiere tarjeta de crédito',

        // Footer
        tagline:
            'Tu plataforma integral de creación de videos e imágenes con IA',
        copyright: 'Copyright © 2025 微鲤AI',
        aiVideoStylization: 'Estilización de Video IA',
        aiVideoEnhancement: 'Mejora de Video IA',
        viewMore: 'Ver más',
        supportedVideoModels: 'Modelos de Video Soportados',
        supportedImageModels: 'Modelos de Imagen Soportados',
        generateVideo: 'Generar Video',
        generateImage: 'Generar Imagen',
    },
    fr: {
        // Navigation Menu
        home: 'Accueil',
        videoAI: 'Vidéo IA',
        imageAI: 'Image IA',
        aiTools: "Kits d'édition",
        pricingLink: 'Tarifs',
        login: 'Connexion',
        startFree: 'Commencer Gratuitement',

        // Homepage Category Titles
        characters: 'Personnages',

        // Video AI Dropdown
        imageToVideoAI: 'Image vers Vidéo IA',
        imageToVideoAIDesc:
            'Transforme des images statiques en vidéos dynamiques réalistes.',
        textToVideoAI: 'Texte vers Vidéo IA',
        textToVideoAIDesc:
            'Convertissez des prompts de texte simples en vidéos époustouflantes.',
        aiVideoEditor: 'Éditeur de Vidéo IA',
        aiVideoEditorDesc:
            'Éditez des vidéos instantanément avec des prompts de texte simples.',
        aiWatermarkRemoval: 'Suppression de Filigrane IA',
        aiWatermarkRemovalDesc:
            'Identifiez et supprimez intelligemment les filigranes des vidéos.',
        aiVideoFaceSwap: 'Échange de Visage Vidéo IA',
        aiVideoFaceSwapDesc:
            "Remplacez le visage d'une personne par un autre dans les vidéos.",
        aiVideoLipSync: 'Synchronisation Labiale Vidéo IA',
        aiVideoLipSyncDesc:
            "Synchronisez parfaitement les personnages vidéo avec l'audio.",
        videoTools: 'Outils vidéo',
        imageTools: "Outils d'image",

        // Image AI Dropdown
        textToImageAI: 'Texte vers Image IA',
        textToImageAIDesc:
            'Transformez les descriptions de texte en belles images.',
        imageToImageAI: 'Image vers Image IA',
        imageToImageAIDesc:
            'Générez de nouvelles variantes basées sur des images existantes.',
        aiImageGenerator: "Générateur d'Images IA",
        aiImageGeneratorDesc:
            'Créez des images uniques en utilisant la technologie IA.',
        aiImageTranslation: "Traduction d'Image IA",
        aiImageTranslationDesc:
            'Traduisez intelligemment le contenu textuel des images.',
        aiImageRatioConversion: "Conversion de Ratio d'Image IA",
        aiImageRatioConversionDesc:
            "Ajustez intelligemment les proportions d'image.",
        aiImageQualityUpgrade: "Amélioration de Qualité d'Image IA",
        aiImageQualityUpgradeDesc:
            'Améliorez la clarté et la qualité des images.',

        // Main Content
        tryFluxKontext: 'Essayer Flux Kontext sur 微鲤AI',
        noCreditCardRequired: 'Aucune carte de crédit requise',

        // Footer
        tagline:
            "Votre plateforme tout-en-un de création de vidéos et d'images IA",
        copyright: 'Copyright © 2025 微鲤AI',
        aiVideoStylization: 'Stylisation Vidéo IA',
        aiVideoEnhancement: 'Amélioration Vidéo IA',
        viewMore: 'Voir plus',
        supportedVideoModels: 'Modèles Vidéo Supportés',
        supportedImageModels: 'Modèles Image Supportés',
        generateVideo: 'Générer Vidéo',
        generateImage: 'Générer Image',
    },
    de: {
        // Navigation Menu
        home: 'Startseite',
        videoAI: 'Video KI',
        imageAI: 'Bild KI',
        aiTools: 'Editor-Toolkits',
        pricingLink: 'Preise',
        login: 'Anmelden',
        startFree: 'Kostenlos Starten',

        // Homepage Category Titles
        characters: 'Charaktere',

        // Video AI Dropdown
        imageToVideoAI: 'Bild zu Video KI',
        imageToVideoAIDesc:
            'Verwandeln Sie statische Bilder in realistische dynamische Videos.',
        textToVideoAI: 'Text zu Video KI',
        textToVideoAIDesc:
            'Verwandeln Sie einfache Textprompts in atemberaubende Videos.',
        aiVideoEditor: 'KI-Video-Editor',
        aiVideoEditorDesc:
            'Bearbeiten Sie Videos sofort mit einfachen Textprompts.',
        aiWatermarkRemoval: 'KI-Wasserzeichen-Entfernung',
        aiWatermarkRemovalDesc:
            'Identifizieren und entfernen Sie intelligent Wasserzeichen aus Videos.',
        aiVideoFaceSwap: 'KI-Video-Gesichtstausch',
        aiVideoFaceSwapDesc:
            'Ersetzen Sie das Gesicht einer Person durch ein anderes in Videos.',
        aiVideoLipSync: 'KI-Video-Lippensynchronisation',
        aiVideoLipSyncDesc:
            'Synchronisieren Sie perfekt Videofiguren mit Audio.',
        videoTools: 'Video-Tools',
        imageTools: 'Bild-Tools',

        // Image AI Dropdown
        textToImageAI: 'Text zu Bild KI',
        textToImageAIDesc:
            'Verwandeln Sie Textbeschreibungen in schöne Bilder.',
        imageToImageAI: 'Bild zu Bild KI',
        imageToImageAIDesc:
            'Generieren Sie neue Varianten basierend auf bestehenden Bildern.',
        aiImageGenerator: 'KI-Bildgenerator',
        aiImageGeneratorDesc:
            'Erstellen Sie einzigartige Bilder mit KI-Technologie.',
        aiImageTranslation: 'KI-Bildübersetzung',
        aiImageTranslationDesc:
            'Übersetzen Sie intelligent Textinhalte in Bildern.',
        aiImageRatioConversion: 'KI-Bildverhältnis-Konvertierung',
        aiImageRatioConversionDesc:
            'Passen Sie intelligent Bildverhältnisse an.',
        aiImageQualityUpgrade: 'KI-Bildqualitätsverbesserung',
        aiImageQualityUpgradeDesc: 'Verbessern Sie Bildschärfe und -qualität.',

        // Main Content
        tryFluxKontext: 'Flux Kontext auf 微鲤AI ausprobieren',
        noCreditCardRequired: 'Keine Kreditkarte erforderlich',

        // Footer
        tagline: 'Ihre All-in-One KI-Video- und Bildgenerierungsplattform',
        copyright: 'Copyright © 2025 微鲤AI',
        aiVideoStylization: 'AI-Video-Stilisierung',
        aiVideoEnhancement: 'AI-Video-Verbesserung',
        viewMore: 'Mehr anzeigen',
        supportedVideoModels: 'Unterstützte Videomodelle',
        supportedImageModels: 'Unterstützte Bildmodelle',
        generateVideo: 'Video generieren',
        generateImage: 'Bild generieren',
    },
    ru: {
        // Navigation Menu
        home: 'Главная',
        videoAI: 'Видео ИИ',
        imageAI: 'Изображение ИИ',
        aiTools: 'Наборы инструментов редактора',
        pricingLink: 'Цены',
        login: 'Войти',
        startFree: 'Начать Бесплатно',

        // Homepage Category Titles
        characters: 'Персонажи',

        // Video AI Dropdown
        imageToVideoAI: 'Изображение в Видео ИИ',
        imageToVideoAIDesc:
            'Преобразуйте статические изображения в реалистичные динамические видео.',
        textToVideoAI: 'Текст в Видео ИИ',
        textToVideoAIDesc:
            'Преобразуйте простые текстовые промпты в потрясающие видео.',
        aiVideoEditor: 'ИИ Видео Редактор',
        aiVideoEditorDesc:
            'Редактируйте видео мгновенно с помощью простых текстовых промптов.',
        aiWatermarkRemoval: 'ИИ Удаление Водяных Знаков',
        aiWatermarkRemovalDesc:
            'Интеллектуально идентифицируйте и удаляйте водяные знаки из видео.',
        aiVideoFaceSwap: 'ИИ Замена Лица в Видео',
        aiVideoFaceSwapDesc: 'Замените лицо одного человека на другое в видео.',
        aiVideoLipSync: 'ИИ Синхронизация Губ в Видео',
        aiVideoLipSyncDesc: 'Идеально синхронизируйте видеоперсонажей с аудио.',
        videoTools: 'Видео инструменты',
        imageTools: 'Инструменты для изображений',

        // Image AI Dropdown
        textToImageAI: 'Текст в Изображение ИИ',
        textToImageAIDesc:
            'Преобразуйте текстовые описания в красивые изображения.',
        imageToImageAI: 'Изображение в Изображение ИИ',
        imageToImageAIDesc:
            'Генерируйте новые варианты на основе существующих изображений.',
        aiImageGenerator: 'ИИ Генератор Изображений',
        aiImageGeneratorDesc:
            'Создавайте уникальные изображения с помощью ИИ-технологии.',
        aiImageTranslation: 'ИИ Перевод Изображений',
        aiImageTranslationDesc:
            'Интеллектуально переводите текстовое содержимое в изображениях.',
        aiImageRatioConversion: 'ИИ Конвертация Пропорций Изображений',
        aiImageRatioConversionDesc:
            'Интеллектуально настраивайте пропорции изображений.',
        aiImageQualityUpgrade: 'ИИ Улучшение Качества Изображений',
        aiImageQualityUpgradeDesc: 'Улучшайте четкость и качество изображений.',

        // Main Content
        tryFluxKontext: 'Try Flux Kontext on 微鲤AI',
        noCreditCardRequired: 'No credit card required',

        // Footer
        tagline:
            'Ваша универсальная платформа для создания видео и изображений с ИИ',
        copyright: 'Copyright © 2025 微鲤AI',
        aiVideoStylization: 'Стилизация ИИ-видео',
        aiVideoEnhancement: 'Улучшение ИИ-видео',
        viewMore: 'Показать больше',
        supportedVideoModels: 'Поддерживаемые видеомодели',
        supportedImageModels: 'Поддерживаемые имидж-модели',
        generateVideo: 'Создать видео',
        generateImage: 'Создать изображение',
    },
    pt: {
        // Navigation Menu
        home: 'Início',
        videoAI: 'Vídeo IA',
        imageAI: 'Imagem IA',
        aiTools: 'Kits de edição',
        pricingLink: 'Preços',
        login: 'Entrar',
        startFree: 'Começar Grátis',

        // Homepage Category Titles
        characters: 'Personagens',

        // Video AI Dropdown
        imageToVideoAI: 'Imagem para Vídeo IA',
        imageToVideoAIDesc:
            'Transforme imagens estáticas em vídeos dinâmicos realistas.',
        textToVideoAI: 'Texto para Vídeo IA',
        textToVideoAIDesc:
            'Converta prompts de texto simples em vídeos impressionantes.',
        aiVideoEditor: 'Editor de Vídeo IA',
        aiVideoEditorDesc:
            'Edite vídeos instantaneamente com prompts de texto simples.',
        aiWatermarkRemoval: "Remoção de Marca d'Água IA",
        aiWatermarkRemovalDesc:
            "Identifique e remova inteligentemente marcas d'água de vídeos.",
        aiVideoFaceSwap: 'Troca de Rosto em Vídeo IA',
        aiVideoFaceSwapDesc:
            'Substitua o rosto de uma pessoa por outro em vídeos.',
        aiVideoLipSync: 'Sincronização Labial em Vídeo IA',
        aiVideoLipSyncDesc:
            'Sincronize perfeitamente personagens de vídeo com áudio.',
        videoTools: 'Ferramentas de vídeo',
        imageTools: 'Ferramentas de imagem',

        // Image AI Dropdown
        textToImageAI: 'Texto para Imagem IA',
        textToImageAIDesc: 'Transforme descrições de texto em imagens bonitas.',
        imageToImageAI: 'Imagem para Imagem IA',
        imageToImageAIDesc:
            'Gere novas variantes baseadas em imagens existentes.',
        aiImageGenerator: 'Gerador de Imagens IA',
        aiImageGeneratorDesc: 'Crie imagens únicas usando tecnologia IA.',
        aiImageTranslation: 'Tradução de Imagem IA',
        aiImageTranslationDesc:
            'Traduza inteligentemente conteúdo de texto em imagens.',
        aiImageRatioConversion: 'Conversão de Proporção de Imagem IA',
        aiImageRatioConversionDesc:
            'Ajuste inteligentemente proporções de imagem.',
        aiImageQualityUpgrade: 'Melhoria de Qualidade de Imagem IA',
        aiImageQualityUpgradeDesc: 'Melhore a clareza e qualidade das imagens.',

        // Main Content
        tryFluxKontext: 'Try Flux Kontext on 微鲤AI',
        noCreditCardRequired: 'No credit card required',

        // Footer
        tagline:
            'Sua plataforma completa de criação de vídeos e imagens com IA',
        copyright: 'Copyright © 2025 微鲤AI',
        aiVideoStylization: 'Estilização de Vídeo IA',
        aiVideoEnhancement: 'Melhoria de Vídeo IA',
        viewMore: 'Ver mais',
        supportedVideoModels: 'Modelos de Vídeo Suportados',
        supportedImageModels: 'Modelos de Imagem Suportados',
        generateVideo: 'Gerar Vídeo',
        generateImage: 'Gerar Imagem',
    },
    it: {
        // Navigation Menu
        home: 'Home',
        videoAI: 'Video IA',
        imageAI: 'Immagine IA',
        aiTools: 'Kit di editing',
        pricingLink: 'Prezzi',
        login: 'Accedi',
        startFree: 'Inizia Gratis',

        // Homepage Category Titles
        characters: 'Personaggi',

        // Video AI Dropdown
        imageToVideoAI: 'Immagine a Video IA',
        imageToVideoAIDesc:
            'Trasforma immagini statiche in video dinamici realistici.',
        textToVideoAI: 'Testo a Video IA',
        textToVideoAIDesc:
            'Converti prompt di testo semplici in video straordinari.',
        aiVideoEditor: 'Editor Video IA',
        aiVideoEditorDesc:
            'Modifica video istantaneamente con prompt di testo semplici.',
        aiWatermarkRemoval: 'Rimozione Filigrana IA',
        aiWatermarkRemovalDesc:
            'Identifica e rimuovi intelligentemente filigrane dai video.',
        aiVideoFaceSwap: 'Scambio Volto Video IA',
        aiVideoFaceSwapDesc:
            'Sostituisci il volto di una persona con un altro nei video.',
        aiVideoLipSync: 'Sincronizzazione Labbra Video IA',
        aiVideoLipSyncDesc:
            'Sincronizza perfettamente personaggi video con audio.',
        videoTools: 'Strumenti video',
        imageTools: 'Strumenti immagine',

        // Image AI Dropdown
        textToImageAI: 'Testo a Immagine IA',
        textToImageAIDesc: 'Trasforma descrizioni di testo in immagini belle.',
        imageToImageAI: 'Immagine a Immagine IA',
        imageToImageAIDesc:
            'Genera nuove varianti basate su immagini esistenti.',
        aiImageGenerator: 'Generatore Immagini IA',
        aiImageGeneratorDesc: 'Crea immagini uniche usando tecnologia IA.',
        aiImageTranslation: 'Traduzione Immagine IA',
        aiImageTranslationDesc:
            'Traduci intelligentemente contenuto testuale nelle immagini.',
        aiImageRatioConversion: 'Conversione Proporzione Immagine IA',
        aiImageRatioConversionDesc:
            'Regola intelligentemente le proporzioni delle immagini.',
        aiImageQualityUpgrade: 'Miglioramento Qualità Immagine IA',
        aiImageQualityUpgradeDesc:
            'Migliora chiarezza e qualità delle immagini.',

        // Main Content
        tryFluxKontext: 'Try Flux Kontext on 微鲤AI',
        noCreditCardRequired: 'No credit card required',

        // Footer
        tagline:
            'La tua piattaforma completa per la creazione di video e immagini con IA',
        copyright: 'Copyright © 2025 微鲤AI',
        aiVideoStylization: 'Stilizzazione Video AI',
        aiVideoEnhancement: 'Miglioramento Video AI',
        viewMore: 'Vedi altro',
        supportedVideoModels: 'Modelli Video Supportati',
        supportedImageModels: 'Modelli Immagine Supportati',
        generateVideo: 'Genera Video',
        generateImage: 'Genera Immagine',
    },
    ar: {
        // Navigation Menu
        home: 'الرئيسية',
        videoAI: 'فيديو ذكاء اصطناعي',
        imageAI: 'صورة ذكاء اصطناعي',
        aiTools: 'حزم أدوات التحرير',
        pricingLink: 'الأسعار',
        login: 'تسجيل الدخول',
        startFree: 'ابدأ مجاناً',

        // Homepage Category Titles
        characters: 'الشخصيات',

        // Video AI Dropdown
        imageToVideoAI: 'صورة إلى فيديو ذكاء اصطناعي',
        imageToVideoAIDesc: 'حول الصور الثابتة إلى فيديوهات ديناميكية واقعية.',
        textToVideoAI: 'نص إلى فيديو ذكاء اصطناعي',
        textToVideoAIDesc: 'حول أوامر النص البسيطة إلى فيديوهات مذهلة.',
        aiVideoEditor: 'محرر فيديو ذكاء اصطناعي',
        aiVideoEditorDesc: 'حرر الفيديوهات فوراً باستخدام أوامر النص البسيطة.',
        aiWatermarkRemoval: 'إزالة العلامة المائية بالذكاء الاصطناعي',
        aiWatermarkRemovalDesc:
            'حدد وأزل العلامات المائية من الفيديوهات بذكاء.',
        aiVideoFaceSwap: 'تبديل الوجه في الفيديو بالذكاء الاصطناعي',
        aiVideoFaceSwapDesc: 'استبدل وجه شخص بآخر في الفيديوهات.',
        aiVideoLipSync: 'مزامنة الشفاه في الفيديو بالذكاء الاصطناعي',
        aiVideoLipSyncDesc: 'زامن شخصيات الفيديو مع الصوت بشكل مثالي.',
        videoTools: 'أدوات الفيديو',
        imageTools: 'أدوات الصور',

        // Image AI Dropdown
        textToImageAI: 'نص إلى صورة ذكاء اصطناعي',
        textToImageAIDesc: 'حول أوصاف النص إلى صور جميلة.',
        imageToImageAI: 'صورة إلى صورة ذكاء اصطناعي',
        imageToImageAIDesc: 'أنتج متغيرات جديدة بناءً على الصور الموجودة.',
        aiImageGenerator: 'مولد الصور بالذكاء الاصطناعي',
        aiImageGeneratorDesc:
            'أنشئ صوراً فريدة باستخدام تقنية الذكاء الاصطناعي.',
        aiImageTranslation: 'ترجمة الصور بالذكاء الاصطناعي',
        aiImageTranslationDesc: 'ترجم محتوى النص في الصور بذكاء.',
        aiImageRatioConversion: 'تحويل نسبة الصور بالذكاء الاصطناعي',
        aiImageRatioConversionDesc: 'اضبط نسب الصور بذكاء.',
        aiImageQualityUpgrade: 'تحسين جودة الصور بالذكاء الاصطناعي',
        aiImageQualityUpgradeDesc: 'حسن وضوح وجودة الصور.',

        // Main Content
        tryFluxKontext: 'Try Flux Kontext on 微鲤AI',
        noCreditCardRequired: 'No credit card required',

        // Footer
        tagline: 'منصتك الشاملة لإنشاء الفيديوهات والصور بالذكاء الاصطناعي',
        copyright: 'حقوق النشر © 2025 微鲤AI',
        aiVideoStylization: 'تنسيق الفيديو بالذكاء الاصطناعي',
        aiVideoEnhancement: 'تحسين الفيديو بالذكاء الاصطناعي',
        viewMore: 'عرض المزيد',
        supportedVideoModels: 'نماذج الفيديو المدعومة',
        supportedImageModels: 'نماذج الصور المدعومة',
        generateVideo: 'إنشاء فيديو',
        generateImage: 'إنشاء صورة',
    },
    // 泰语
    th: {
        // Navigation Menu
        home: 'หน้าแรก',
        videoAI: 'วิดีโอ AI',
        imageAI: 'รูปภาพ AI',
        aiTools: 'ชุดเครื่องมือแก้ไข',
        pricingLink: 'ราคา',
        login: 'เข้าสู่ระบบ',
        startFree: 'เริ่มต้นฟรี',

        // Homepage Category Titles
        characters: 'ตัวละคร',

        // Video AI Dropdown
        imageToVideoAI: 'รูปภาพเป็นวิดีโอ AI',
        imageToVideoAIDesc: 'แปลงภาพนิ่งเป็นวิดีโอไดนามิกที่สมจริง',
        textToVideoAI: 'ข้อความเป็นวิดีโอ AI',
        textToVideoAIDesc: 'แปลงข้อความง่ายๆ เป็นวิดีโอที่น่าทึ่ง',
        aiVideoEditor: 'โปรแกรมตัดต่อวิดีโอ AI',
        aiVideoEditorDesc: 'แก้ไขวิดีโอทันทีด้วยข้อความง่ายๆ',
        aiWatermarkRemoval: 'AI ลบลายน้ำ',
        aiWatermarkRemovalDesc: 'ระบุและลบลายน้ำจากวิดีโออย่างชาญฉลาด',
        aiVideoFaceSwap: 'AI สลับใบหน้าในวิดีโอ',
        aiVideoFaceSwapDesc: 'แทนที่ใบหน้าของคนหนึ่งด้วยอีกคนในวิดีโอ',
        aiVideoLipSync: 'AI ซิงค์ปากในวิดีโอ',
        aiVideoLipSyncDesc: 'ซิงโครไนซ์ตัวละครในวิดีโอกับเสียงอย่างสมบูรณ์แบบ',
        aiVideoStylization: 'AI จัดสไตล์วิดีโอ',
        aiVideoEnhancement: 'AI ปรับปรุงวิดีโอ',

        // Image AI Dropdown
        textToImageAI: 'ข้อความเป็นรูปภาพ AI',
        textToImageAIDesc: 'แปลงคำอธิบายข้อความเป็นรูปภาพที่สวยงาม',
        imageToImageAI: 'รูปภาพเป็นรูปภาพ AI',
        imageToImageAIDesc: 'สร้างรูปแบบใหม่จากรูปภาพที่มีอยู่',
        aiImageGenerator: 'AI สร้างรูปภาพ',
        aiImageGeneratorDesc: 'สร้างรูปภาพที่ไม่ซ้ำใครด้วยเทคโนโลยี AI',
        aiImageTranslation: 'AI แปลรูปภาพ',
        aiImageTranslationDesc: 'แปลเนื้อหาข้อความในรูปภาพอย่างชาญฉลาด',
        aiImageRatioConversion: 'AI แปลงอัตราส่วนรูปภาพ',
        aiImageRatioConversionDesc: 'ปรับอัตราส่วนภาพอย่างชาญฉลาด',
        aiImageQualityUpgrade: 'AI อัปเกรดคุณภาพรูปภาพ',
        aiImageQualityUpgradeDesc: 'เพิ่มความคมชัดและคุณภาพของรูปภาพ',

        // AI Tools Categories
        videoTools: 'เครื่องมือวิดีโอ',
        imageTools: 'เครื่องมือรูปภาพ',
        viewMore: 'ดูเพิ่มเติม',
        supportedVideoModels: 'โมเดลวิดีโอที่รองรับ',
        supportedImageModels: 'โมเดลรูปภาพที่รองรับ',

        // Main Content
        generateVideo: 'สร้างวิดีโอ',
        generateImage: 'สร้างรูปภาพ',
        tryFluxKontext: 'ลอง Flux Kontext บน 微鲤AI',
        noCreditCardRequired: 'ไม่ต้องใช้บัตรเครดิต',

        // Footer
        tagline: 'แพลตฟอร์มสร้างวิดีโอและรูปภาพ AI ครบวงจรของคุณ',
        copyright: 'ลิขสิทธิ์ © 2025 微鲤AI',
    },
    // 丹麦语
    da: {
        // Navigation Menu
        home: 'Hjem',
        videoAI: 'Video AI',
        imageAI: 'Billede AI',
        aiTools: 'Redigeringsværktøjer',
        pricingLink: 'Priser',
        login: 'Log ind',
        startFree: 'Start gratis',

        // Homepage Category Titles
        characters: 'Karakterer',

        // Video AI Dropdown
        imageToVideoAI: 'Billede til Video AI',
        imageToVideoAIDesc: 'Transformer statiske billeder til realistiske dynamiske videoer.',
        textToVideoAI: 'Tekst til Video AI',
        textToVideoAIDesc: 'Konverter simple tekstprompter til fantastiske videoer.',
        aiVideoEditor: 'AI Video Editor',
        aiVideoEditorDesc: 'Rediger videoer øjeblikkeligt med simple tekstprompter.',
        aiWatermarkRemoval: 'AI Vandmærkefjernelse',
        aiWatermarkRemovalDesc: 'Identificer og fjern intelligent vandmærker fra videoer.',
        aiVideoFaceSwap: 'AI Video Ansigtsbytte',
        aiVideoFaceSwapDesc: 'Erstat en persons ansigt med et andet i videoer.',
        aiVideoLipSync: 'AI Video Læbesynkronisering',
        aiVideoLipSyncDesc: 'Synkroniser perfekt videokarakterer med lyd.',
        aiVideoStylization: 'AI Video Stilisering',
        aiVideoEnhancement: 'AI Video Forbedring',

        // Image AI Dropdown
        textToImageAI: 'Tekst til Billede AI',
        textToImageAIDesc: 'Transformer tekstbeskrivelser til smukke billeder.',
        imageToImageAI: 'Billede til Billede AI',
        imageToImageAIDesc: 'Generer nye varianter baseret på eksisterende billeder.',
        aiImageGenerator: 'AI Billedgenerator',
        aiImageGeneratorDesc: 'Opret unikke billeder ved hjælp af AI-teknologi.',
        aiImageTranslation: 'AI Billedoversættelse',
        aiImageTranslationDesc: 'Oversæt intelligent tekstindhold i billeder.',
        aiImageRatioConversion: 'AI Billedforholdskonvertering',
        aiImageRatioConversionDesc: 'Juster intelligent billedforhold.',
        aiImageQualityUpgrade: 'AI Billedkvalitetsforbedring',
        aiImageQualityUpgradeDesc: 'Forbedre billedklarhed og kvalitet.',

        // AI Tools Categories
        videoTools: 'Videoværktøjer',
        imageTools: 'Billedværktøjer',
        viewMore: 'Se mere',
        supportedVideoModels: 'Understøttede videomodeller',
        supportedImageModels: 'Understøttede billedmodeller',

        // Main Content
        generateVideo: 'Generer video',
        generateImage: 'Generer billede',
        tryFluxKontext: 'Prøv Flux Kontext på 微鲤AI',
        noCreditCardRequired: 'Intet kreditkort påkrævet',

        // Footer
        tagline: 'Din alt-i-én AI video- og billedskabelsesplatform',
        copyright: 'Copyright © 2025 微鲤AI',
    },
    // 挪威语
    no: {
        // Navigation Menu
        home: 'Hjem',
        videoAI: 'Video AI',
        imageAI: 'Bilde AI',
        aiTools: 'Redigeringsverktøy',
        pricingLink: 'Priser',
        login: 'Logg inn',
        startFree: 'Start gratis',

        // Homepage Category Titles
        characters: 'Karakterer',

        // Video AI Dropdown
        imageToVideoAI: 'Bilde til Video AI',
        imageToVideoAIDesc: 'Transformer statiske bilder til realistiske dynamiske videoer.',
        textToVideoAI: 'Tekst til Video AI',
        textToVideoAIDesc: 'Konverter enkle tekstprompter til fantastiske videoer.',
        aiVideoEditor: 'AI Video Editor',
        aiVideoEditorDesc: 'Rediger videoer umiddelbart med enkle tekstprompter.',
        aiWatermarkRemoval: 'AI Vannmerkefjernelse',
        aiWatermarkRemovalDesc: 'Identifiser og fjern intelligent vannmerker fra videoer.',
        aiVideoFaceSwap: 'AI Video Ansiktsbytte',
        aiVideoFaceSwapDesc: 'Erstatt en persons ansikt med et annet i videoer.',
        aiVideoLipSync: 'AI Video Leppesynkronisering',
        aiVideoLipSyncDesc: 'Synkroniser perfekt videokarakterer med lyd.',
        aiVideoStylization: 'AI Video Stilisering',
        aiVideoEnhancement: 'AI Video Forbedring',

        // Image AI Dropdown
        textToImageAI: 'Tekst til Bilde AI',
        textToImageAIDesc: 'Transformer tekstbeskrivelser til vakre bilder.',
        imageToImageAI: 'Bilde til Bilde AI',
        imageToImageAIDesc: 'Generer nye varianter basert på eksisterende bilder.',
        aiImageGenerator: 'AI Bildegenerator',
        aiImageGeneratorDesc: 'Lag unike bilder ved hjelp av AI-teknologi.',
        aiImageTranslation: 'AI Bildeoversettelse',
        aiImageTranslationDesc: 'Oversett intelligent tekstinnhold i bilder.',
        aiImageRatioConversion: 'AI Bildeforholdskonvertering',
        aiImageRatioConversionDesc: 'Juster intelligent bildeforhold.',
        aiImageQualityUpgrade: 'AI Bildekvalitetsforbedring',
        aiImageQualityUpgradeDesc: 'Forbedre bildeklarhet og kvalitet.',

        // AI Tools Categories
        videoTools: 'Videoverktøy',
        imageTools: 'Bildeverktøy',
        viewMore: 'Se mer',
        supportedVideoModels: 'Støttede videomodeller',
        supportedImageModels: 'Støttede bildemodeller',

        // Main Content
        generateVideo: 'Generer video',
        generateImage: 'Generer bilde',
        tryFluxKontext: 'Prøv Flux Kontext på 微鲤AI',
        noCreditCardRequired: 'Ingen kredittkort nødvendig',

        // Footer
        tagline: 'Din alt-i-ett AI video- og bildeskapelsesplattform',
        copyright: 'Copyright © 2025 微鲤AI',
    },
    // 荷兰语
    nl: {
        // Navigation Menu
        home: 'Home',
        videoAI: 'Video AI',
        imageAI: 'Afbeelding AI',
        aiTools: 'Bewerkingstools',
        pricingLink: 'Prijzen',
        login: 'Inloggen',
        startFree: 'Gratis starten',

        // Homepage Category Titles
        characters: 'Karakters',

        // Video AI Dropdown
        imageToVideoAI: 'Afbeelding naar Video AI',
        imageToVideoAIDesc: 'Transformeer statische afbeeldingen in realistische dynamische videos.',
        textToVideoAI: 'Tekst naar Video AI',
        textToVideoAIDesc: 'Converteer eenvoudige tekstprompts naar verbluffende videos.',
        aiVideoEditor: 'AI Video Editor',
        aiVideoEditorDesc: 'Bewerk videos direct met eenvoudige tekstprompts.',
        aiWatermarkRemoval: 'AI Watermerkverwijdering',
        aiWatermarkRemovalDesc: 'Identificeer en verwijder intelligent watermerken uit videos.',
        aiVideoFaceSwap: 'AI Video Gezichtswissel',
        aiVideoFaceSwapDesc: 'Vervang het gezicht van iemand door een ander in videos.',
        aiVideoLipSync: 'AI Video Lipsynchronisatie',
        aiVideoLipSyncDesc: 'Synchroniseer perfect videokarakters met audio.',
        aiVideoStylization: 'AI Video Stilering',
        aiVideoEnhancement: 'AI Video Verbetering',

        // Image AI Dropdown
        textToImageAI: 'Tekst naar Afbeelding AI',
        textToImageAIDesc: 'Transformeer tekstbeschrijvingen naar mooie afbeeldingen.',
        imageToImageAI: 'Afbeelding naar Afbeelding AI',
        imageToImageAIDesc: 'Genereer nieuwe varianten op basis van bestaande afbeeldingen.',
        aiImageGenerator: 'AI Afbeeldinggenerator',
        aiImageGeneratorDesc: 'Maak unieke afbeeldingen met AI-technologie.',
        aiImageTranslation: 'AI Afbeeldingvertaling',
        aiImageTranslationDesc: 'Vertaal intelligent tekstinhoud in afbeeldingen.',
        aiImageRatioConversion: 'AI Afbeeldingverhoudingsconversie',
        aiImageRatioConversionDesc: 'Pas intelligent afbeeldingverhoudingen aan.',
        aiImageQualityUpgrade: 'AI Afbeeldingkwaliteitsverbetering',
        aiImageQualityUpgradeDesc: 'Verbeter afbeeldingshelderheid en kwaliteit.',

        // AI Tools Categories
        videoTools: 'Videotools',
        imageTools: 'Afbeeldingstools',
        viewMore: 'Meer bekijken',
        supportedVideoModels: 'Ondersteunde videomodellen',
        supportedImageModels: 'Ondersteunde afbeeldingsmodellen',

        // Main Content
        generateVideo: 'Genereer video',
        generateImage: 'Genereer afbeelding',
        tryFluxKontext: 'Probeer Flux Kontext op 微鲤AI',
        noCreditCardRequired: 'Geen creditcard vereist',

        // Footer
        tagline: 'Uw alles-in-één AI video- en afbeeldingcreatieplatform',
        copyright: 'Copyright © 2025 微鲤AI',
    },
    // 印尼语
    id: {
        // Navigation Menu
        home: 'Beranda',
        videoAI: 'Video AI',
        imageAI: 'Gambar AI',
        aiTools: 'Alat Pengeditan',
        pricingLink: 'Harga',
        login: 'Masuk',
        startFree: 'Mulai Gratis',

        // Homepage Category Titles
        characters: 'Karakter',

        // Video AI Dropdown
        imageToVideoAI: 'Gambar ke Video AI',
        imageToVideoAIDesc: 'Ubah gambar statis menjadi video dinamis yang realistis.',
        textToVideoAI: 'Teks ke Video AI',
        textToVideoAIDesc: 'Ubah prompt teks sederhana menjadi video yang menakjubkan.',
        aiVideoEditor: 'Editor Video AI',
        aiVideoEditorDesc: 'Edit video secara instan dengan prompt teks sederhana.',
        aiWatermarkRemoval: 'Penghapusan Watermark AI',
        aiWatermarkRemovalDesc: 'Identifikasi dan hapus watermark dari video secara cerdas.',
        aiVideoFaceSwap: 'Tukar Wajah Video AI',
        aiVideoFaceSwapDesc: 'Ganti wajah seseorang dengan yang lain dalam video.',
        aiVideoLipSync: 'Sinkronisasi Bibir Video AI',
        aiVideoLipSyncDesc: 'Sinkronkan karakter video dengan audio secara sempurna.',
        aiVideoStylization: 'Stilisasi Video AI',
        aiVideoEnhancement: 'Peningkatan Video AI',

        // Image AI Dropdown
        textToImageAI: 'Teks ke Gambar AI',
        textToImageAIDesc: 'Ubah deskripsi teks menjadi gambar yang indah.',
        imageToImageAI: 'Gambar ke Gambar AI',
        imageToImageAIDesc: 'Hasilkan varian baru berdasarkan gambar yang ada.',
        aiImageGenerator: 'Generator Gambar AI',
        aiImageGeneratorDesc: 'Buat gambar unik menggunakan teknologi AI.',
        aiImageTranslation: 'Terjemahan Gambar AI',
        aiImageTranslationDesc: 'Terjemahkan konten teks dalam gambar secara cerdas.',
        aiImageRatioConversion: 'Konversi Rasio Gambar AI',
        aiImageRatioConversionDesc: 'Sesuaikan rasio aspek gambar secara cerdas.',
        aiImageQualityUpgrade: 'Peningkatan Kualitas Gambar AI',
        aiImageQualityUpgradeDesc: 'Tingkatkan kejelasan dan kualitas gambar.',

        // AI Tools Categories
        videoTools: 'Alat Video',
        imageTools: 'Alat Gambar',
        viewMore: 'Lihat Selengkapnya',
        supportedVideoModels: 'Model Video yang Didukung',
        supportedImageModels: 'Model Gambar yang Didukung',

        // Main Content
        generateVideo: 'Hasilkan Video',
        generateImage: 'Hasilkan Gambar',
        tryFluxKontext: 'Coba Flux Kontext di 微鲤AI',
        noCreditCardRequired: 'Tidak perlu kartu kredit',

        // Footer
        tagline: 'Platform pembuatan video dan gambar AI lengkap Anda',
        copyright: 'Hak Cipta © 2025 微鲤AI',
    },
    // 土耳其语
    tr: {
        // Navigation Menu
        home: 'Ana Sayfa',
        videoAI: 'Video AI',
        imageAI: 'Görsel AI',
        aiTools: 'Düzenleme Araçları',
        pricingLink: 'Fiyatlandırma',
        login: 'Giriş Yap',
        startFree: 'Ücretsiz Başla',

        // Homepage Category Titles
        characters: 'Karakterler',

        // Video AI Dropdown
        imageToVideoAI: 'Görselden Videoya AI',
        imageToVideoAIDesc: 'Statik görselleri gerçekçi dinamik videolara dönüştürün.',
        textToVideoAI: 'Metinden Videoya AI',
        textToVideoAIDesc: 'Basit metin istemlerini çarpıcı videolara dönüştürün.',
        aiVideoEditor: 'AI Video Düzenleyici',
        aiVideoEditorDesc: 'Basit metin istemleriyle videoları anında düzenleyin.',
        aiWatermarkRemoval: 'AI Filigran Kaldırma',
        aiWatermarkRemovalDesc: 'Videolardan filigranları akıllıca tanımlayın ve kaldırın.',
        aiVideoFaceSwap: 'AI Video Yüz Değiştirme',
        aiVideoFaceSwapDesc: 'Videolarda bir kişinin yüzünü başka biriyle değiştirin.',
        aiVideoLipSync: 'AI Video Dudak Senkronizasyonu',
        aiVideoLipSyncDesc: 'Video karakterlerini sesle mükemmel şekilde senkronize edin.',
        aiVideoStylization: 'AI Video Stilizasyonu',
        aiVideoEnhancement: 'AI Video İyileştirme',

        // Image AI Dropdown
        textToImageAI: 'Metinden Görsele AI',
        textToImageAIDesc: 'Metin açıklamalarını güzel görsellere dönüştürün.',
        imageToImageAI: 'Görselden Görsele AI',
        imageToImageAIDesc: 'Mevcut görsellere dayalı yeni varyantlar oluşturun.',
        aiImageGenerator: 'AI Görsel Oluşturucu',
        aiImageGeneratorDesc: 'AI teknolojisini kullanarak benzersiz görseller oluşturun.',
        aiImageTranslation: 'AI Görsel Çevirisi',
        aiImageTranslationDesc: 'Görsellerdeki metin içeriğini akıllıca çevirin.',
        aiImageRatioConversion: 'AI Görsel Oran Dönüştürme',
        aiImageRatioConversionDesc: 'Görsel en-boy oranlarını akıllıca ayarlayın.',
        aiImageQualityUpgrade: 'AI Görsel Kalite İyileştirme',
        aiImageQualityUpgradeDesc: 'Görsel netliğini ve kalitesini artırın.',

        // AI Tools Categories
        videoTools: 'Video Araçları',
        imageTools: 'Görsel Araçları',
        viewMore: 'Daha Fazla Gör',
        supportedVideoModels: 'Desteklenen Video Modelleri',
        supportedImageModels: 'Desteklenen Görsel Modelleri',

        // Main Content
        generateVideo: 'Video Oluştur',
        generateImage: 'Görsel Oluştur',
        tryFluxKontext: '微鲤AI\'de Flux Kontext\'i Deneyin',
        noCreditCardRequired: 'Kredi kartı gerekli değil',

        // Footer
        tagline: 'Hepsi bir arada AI video ve görsel oluşturma platformunuz',
        copyright: 'Telif Hakkı © 2025 微鲤AI',
    },
}
